/**
 * "Core concepts" documentation section (ADR-0074).
 * The explanation layer beneath the Introduction: how Syncanix safely turns your
 * API into actions the assistant can take.
 */
import { BOUNDARIES_PAGE } from './pages/boundaries.page';
import { BROWSER_GATE_PAGE } from './pages/browser-gate.page';
import { CATALOG_PAGE } from './pages/catalog.page';
import { CONFIRMATION_PAGE } from './pages/confirmation.page';
import { IDENTITY_PAGE } from './pages/identity.page';
import { MEMORY_PAGE } from './pages/memory.page';
import { RELIABILITY_PAGE } from './pages/reliability.page';
import { RENDERING_PAGE } from './pages/rendering.page';

import type { DocSection } from './types';

export const CORE_CONCEPTS_SECTION: DocSection = {
  id: 'core-concepts',
  titleKey: 'docs.section.coreConcepts.title',
  pages: [
    CATALOG_PAGE,
    BROWSER_GATE_PAGE,
    BOUNDARIES_PAGE,
    IDENTITY_PAGE,
    CONFIRMATION_PAGE,
    RENDERING_PAGE,
    RELIABILITY_PAGE,
    MEMORY_PAGE,
  ],
};
